import { render } from "./BoxSlot.vue?vue&type=template&id=85a3e676&scoped=true"
import script from "./BoxSlot.vue?vue&type=script&lang=js"
export * from "./BoxSlot.vue?vue&type=script&lang=js"

import "./BoxSlot.vue?vue&type=style&index=0&id=85a3e676&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85a3e676"]])

export default __exports__